import "./App.css";
import Dictionary from "./Dictionary.js";
import Footer from "./Footer";

function App() {
  return (
    <div className="container">
      <Dictionary />
      <Footer />
    </div>
  );
}

export default App;
